import React from 'react';
import { Box } from '@chakra-ui/react';
import { getTabBadgeStyles } from './tabs-badge-theme';
import {
  ColorMode,
  useColorMode,
} from '@allergan-data-labs/alle-elements-core';

export interface TabBadgeProps {
  badgeIndex: number;
  colorMode?: ColorMode;
}

export const TabBadge = ({
  badgeIndex: index,
  colorMode: propColorMode,
}: TabBadgeProps) => {
  const { colorMode } = useColorMode(propColorMode);

  return (
    <Box
      data-testid={`tab-badge-${index + 1}`}
      sx={getTabBadgeStyles(colorMode)}
    >
      {index + 1}
    </Box>
  );
};
